import React from "react";
import { EventWizardProvider } from "./useWizardContext";
import RequirementPostingWizard from "./RequirementPostingWizard";

export default function EventWizard() {
  return (
    <EventWizardProvider>
      <RequirementPostingWizard />
    </EventWizardProvider>
  );
}
